import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft } from "lucide-react";
import "./SelectProfilePage.css";
import appIcon from "../../assets/appIcon.svg";
import MobileTopBar from "../../components/MobileTopBar";
import DesktopTopBar from "../../components/DesktopTopBar";

const SelectProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useSelector((state) => state.user);

  const role = profile.user_dog_status === 1 ? "paws" : "social";
  const dogName = profile?.dogs?.[0]?.dog_name || "DOG'S";
  const userName = profile?.user_name || "PAWRENT";

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate("/user-profile");
    }
  };

  const handleEditDog = () => {
    navigate("/edit-dog-details");
  };

  const handleEditUser = () => {
    navigate("/edit-user-details");
  };

  return (
    <div className="sp-edit-selection-container">
      <DesktopTopBar showBack={true} onBack={handleBack} backColor="#fff" />

      {/* Mobile Top Bar (Tablet/Mobile) */}
      <div className="sp-mobile-only">
        <MobileTopBar onBack={handleBack} backColor="#fff" logoColor="#fff" />
      </div>

      {/* Main Content */}
      <main className="sp-selection-content">
        <h1 className="sp-selection-title">SELECT PROFILE TO EDIT</h1>

        <div className="sp-button-group">
          {role === "paws" && (
            <button className="sp-profile-select-btn" onClick={handleEditDog}>
              {dogName.toUpperCase()}'S PROFILE
            </button>
          )}

          <button className="sp-profile-select-btn" onClick={handleEditUser}>
            {userName.toUpperCase()}'S PROFILE
          </button>
        </div>
      </main>
    </div>
  );
};

export default SelectProfilePage;
